import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
let ChapterWideScreenMsg = class ChapterWideScreenMsg extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "icon", void 0);
    _defineProperty(this, "message", void 0);
  }
};
__decorate([Prop({
  default: ''
})], ChapterWideScreenMsg.prototype, "icon", void 0);
__decorate([Prop({
  default: ''
})], ChapterWideScreenMsg.prototype, "message", void 0);
ChapterWideScreenMsg = __decorate([Component({
  components: {
    Icon
  }
})], ChapterWideScreenMsg);
export default ChapterWideScreenMsg;